import produce from 'immer';
import {
  types,
  AuthState,
  AuthActionTypes,
  AdminLoginSuccess,
  AdminLoginPending,
  AdminLoginError,
  AdminPinValidationPending,
  AdminPinValidationError,
  MaintenanceLoginSuccess,
  MaintenanceLoginPending,
  MaintenanceLoginError,
  DemoLoginRequest,
  DemoLoginSuccess,
  DemoLoginError,
  DemoLoginPending
} from './types';

// Actions
export const actions = {
  adminLogin: (payload: { email: string; password: string }): AuthActionTypes => ({
    type: types.ADMIN_LOGIN_ASYNC.REQUEST,
    payload
  }),
  adminPinValidation: (payload: { pinCode: string }): AuthActionTypes => ({
    type: types.ADMIN_PIN_VALIDATION_ASYNC.REQUEST,
    payload
  }),
  maintenanceLogin: (payload: { pinCode: string }): AuthActionTypes => ({
    type: types.MAINTENANCE_LOGIN_ASYNC.REQUEST,
    payload
  }),
  demoLogin: (payload: DemoLoginRequest['payload']): AuthActionTypes => ({
    type: types.DEMO_LOGIN_ASYNC.REQUEST,
    payload
  }),
  removeMaintenanceToken: (): AuthActionTypes => ({
    type: types.REMOVE_MAINTENANCE_TOKEN
  }),
  removeAdminToken: (): AuthActionTypes => ({ type: types.REMOVE_ADMIN_TOKEN }),
  resetMaintenanceMessage: (): AuthActionTypes => ({ type: types.RESET_MAINTENANCE_MESSAGE }),
  resetAdminMessage: (): AuthActionTypes => ({ type: types.RESET_ADMIN_MESSAGE }),
  resetAdminPinMessage: (): AuthActionTypes => ({ type: types.RESET_ADMIN_PIN_MESSAGE }),
  resetAdminPinAuthorized: (): AuthActionTypes => ({ type: types.RESET_ADMIN_PIN_AUTHORIZED })
};

// Initial State
export const initialState: AuthState = {
  admin: {},
  maintenance: {},
  adminPinAuthorized: false,
  loading: false,
  adminError: undefined,
  maintenanceError: undefined,
  adminPinError: undefined
};

// Reducer
export const reducer = (state: AuthState = initialState, action: AuthActionTypes): AuthState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.REMOVE_MAINTENANCE_TOKEN:
        draft.maintenance = {};
        break;
      case types.ADMIN_LOGIN_ASYNC.SUCCESS:
      case types.DEMO_LOGIN_ASYNC.SUCCESS:
        draft.admin = (action as AdminLoginSuccess | DemoLoginSuccess).payload;
        draft.adminError = undefined;
        break;
      case types.ADMIN_PIN_VALIDATION_ASYNC.SUCCESS:
        draft.adminPinError = undefined;
        draft.adminPinAuthorized = true;
        break;
      case types.MAINTENANCE_LOGIN_ASYNC.SUCCESS:
        draft.maintenance = (action as MaintenanceLoginSuccess).payload;
        draft.maintenanceError = undefined;
        break;
      case types.ADMIN_LOGIN_ASYNC.ERROR:
      case types.DEMO_LOGIN_ASYNC.ERROR:
        draft.adminError = (action as AdminLoginError | DemoLoginError).payload;
        break;
      case types.ADMIN_PIN_VALIDATION_ASYNC.ERROR:
        draft.adminPinError = (action as AdminPinValidationError).payload;
        break;
      case types.MAINTENANCE_LOGIN_ASYNC.ERROR:
        draft.maintenanceError = (action as MaintenanceLoginError).payload;
        break;
      case types.ADMIN_LOGIN_ASYNC.PENDING:
      case types.ADMIN_PIN_VALIDATION_ASYNC.PENDING:
      case types.MAINTENANCE_LOGIN_ASYNC.PENDING:
      case types.DEMO_LOGIN_ASYNC.PENDING:
        draft.loading = (
          action as AdminLoginPending | AdminPinValidationPending | MaintenanceLoginPending | DemoLoginPending
        ).payload;
        break;
      case types.REMOVE_ADMIN_TOKEN:
        draft.admin = {};
        break;
      case types.RESET_MAINTENANCE_MESSAGE:
        draft.maintenanceError = undefined;
        break;
      case types.RESET_ADMIN_MESSAGE:
        draft.adminError = undefined;
        break;
      case types.RESET_ADMIN_PIN_MESSAGE:
        draft.adminPinError = undefined;
        break;
      case types.RESET_ADMIN_PIN_AUTHORIZED:
        draft.adminPinAuthorized = false;
        break;
      default:
    }
  });
};
